import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SessionUser } from '../../models/session-user.model';

@Component({
  selector: 'app-account-access',
  imports: [RouterLink],
  templateUrl: './account-access.html',
  styleUrl: './account-access.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.compact]': 'compact()' },
})
export class AccountAccess {
  readonly user = input.required<SessionUser>();
  readonly compact = input(false);
  readonly profileOpened = output<void>();
  readonly signOut = output<void>();
}
